module.exports = "/_next/static/images/noImage4x3-0c3c56cf9c15a39d25c7787bdd051c48.jpg";